// extracted by mini-css-extract-plugin
export default {"tokens":"\"../../styles/tokens.css\"","black":"#303030","white":"#FFFFFF","logo":"styles_logo__Xz0Kb","big":"styles_big__8TcHf","light":"styles_light__Ts91G"};